import { render, staticRenderFns } from "./TeachBrandsAddLayer.vue?vue&type=template&id=2af0b6f7&scoped=true&"
import script from "./TeachBrandsAddLayer.vue?vue&type=script&lang=js&"
export * from "./TeachBrandsAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./TeachBrandsAddLayer.vue?vue&type=style&index=0&id=2af0b6f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0b6f7",
  null
  
)

export default component.exports